import { Route, Routes } from "react-router-dom";
// import PendingAppointments from "../child_components/PendingAppointments";
import UpcomingAppointments from "../child_components/UpcomingAppointments";
import CancelledAppointments from "../child_components/CancelledAppointments";

function Appointments() {

    return(
            <Routes>
                {/* <Route path="/pending" element={ <PendingAppointments /> } /> */}
                <Route path="/upcoming" element={ <UpcomingAppointments /> } />
                <Route path="/cancelled" element={ <CancelledAppointments /> } />
            </Routes>
    )
}

export default Appointments;